const routes = [
  {
    path: '/kepuyuan/manage',
    name: 'kepuyuan-manage',
    component: () => import('@/views/kepuyuan/KepuyuanManage.vue'),
    meta: {
      title: '科普员管理',
    },
  },
  {
    path: '/kepuyuan/regional',
    name: 'kepuyuan-regional',
    component: () => import('@/views/kepuyuan/KepuyuanRegional.vue'),
    meta: {
      title: '地区数据',
    },
  },
  {
    path: '/kepuyuan/realtime',
    name: 'kepuyuan-realtime',
    component: () => import('@/views/kepuyuan/KepuyuanRealTime.vue'),
    meta: {
      title: '实时数据',
    },
  },
  {
    path: '/kepuyuan/mapprovice',
    name: 'kepuyuan-mapprovice',
    component: () => import('@/views/kepuyuan/MapProvice.vue'),
    meta: {
      title: '地图详情',
    },
  },

  {
    path: '/kepuyuan/institutionmore',
    name: 'kepuyuan-institution-more',
    component: () => import('@/views/kepuyuan/KepuyuanInstitutionMore.vue'),
    meta: {
      title: '机构传播量',
    },
  },
];
export default routes;
